import { AxiosPromise, AxiosResponse } from 'axios'
import { Loading } from 'quasar'
import { loaderSettings } from 'src/components/Loading'
import client from 'src/domains/api/client'

export default function(url: string, fileName: string, timeout: number = 5000): AxiosPromise {
  Loading.show(loaderSettings)
  const result = client.request({
    url,
    method: 'GET',
    responseType: 'blob',
    timeout,
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then((response: AxiosResponse): any => {
      download(response.data, fileName)
    })
    .finally((): void => Loading.hide())

  return result
}

export function download(content: string, fileName: string): void {
  const downloadUrl = window.URL.createObjectURL(new Blob([content]))

  const link = document.createElement('a')
  link.href = downloadUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}
